import React from 'react';
import { useCollectionItem, useCollection } from '../hooks/useCollectionItem';
import { renderCollectionItem } from '../utils/collectionUtils';

interface CollectionItemHoverCardProps {
  collectionId: number;
  itemId: number;
  itemName: string;
  onViewCheckins: () => void;
}

export const CollectionItemHoverCard: React.FC<CollectionItemHoverCardProps> = ({
  collectionId,
  itemId,
  itemName,
  onViewCheckins
}) => {
  const { item, loading } = useCollectionItem(collectionId, String(itemId));
  const { collection } = useCollection(collectionId);

  if (loading || !item || !collection) {
    return (
      <div className="p-4 min-w-64 max-w-96">
        <div className="text-sm text-gray-500">Loading...</div>
      </div>
    );
  }

  const pictureField = collection.config?.fields?.['picture'];
  const pictureValue = pictureField && item.data?.['picture'];

  return (
    <div className="p-4 min-w-64 max-w-96 bg-white rounded-lg">
      <div className="mb-3">
        <div className="text-xs text-gray-500 mb-1">{collection.name || 'Collection'}</div>
        <h6 className="text-sm font-semibold text-gray-900 mb-0">{renderCollectionItem(item, collection)}</h6>
      </div>
      
      {pictureValue && (
        <div className="mb-4">
          <img 
            src={pictureValue} 
            alt={itemName}
            className="w-full h-auto max-h-48 object-cover rounded-md"
          />
        </div>
      )}
      
      <button 
        className="w-full px-4 py-2 text-sm font-medium text-plum bg-action hover:bg-action-dark rounded-md transition-colors duration-200"
        onClick={(e) => {
          e.stopPropagation();
          onViewCheckins();
        }}
      >
        View checkins containing "{itemName}"
      </button>
    </div>
  );
};